// Generated by ReScript, PLEASE EDIT WITH CARE

function humanizeSort(sort) {
  switch (sort) {
    case /* Default */0:
      return "Default";
    case /* Featured */1:
      return "Featured";
    case /* BestSellers */2:
      return "Best Sellers";
    case /* Newest */3:
      return "New Arrivals";
    case /* HighestPrice */4:
      return "Price: High-Low";
    case /* LowestPrice */5:
      return "Price: Low-High";
    case /* HighestDiscount */6:
      return "Highest Discount";
  }
}
export { humanizeSort };
/* No side effect */